import ArticleLayout from "@/components/feature/ArticleLayout";
import { newArticles } from "@/mocks/articles";

export default function FaqHoobuySpreadsheet() {
  return <ArticleLayout article={newArticles[7]} />;
}